import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PopUpContainer from 'src/components/common/modal/PopUp';
import './styles.scss';

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SafeTermsAndConditionsModal: FC<IProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const { t }: Translation = useTranslation();

  return (
    <PopUpContainer
      isOpen={isOpen}
      handleClose={onClose}
      hasOverlay
      title={t('safe_promo.safe_terms_and_condition_modal_title')}
      zIndex={250}
      type="fullSize"
    >
      <div className="safe_terms_and_condition_modal_content"></div>
    </PopUpContainer>
  );
};

export default SafeTermsAndConditionsModal;
